import React from 'react'
import { useIsSidebarCollapsed } from '../../store/useSidebarStore'
import styles from './SidebarItem.module.css'

export type SidebarItemProps = {
    icon?: React.ReactNode
    text?: React.ReactNode
}

export const SidebarItem = ({ icon, text }: SidebarItemProps) => {
    const isCollapsed = useIsSidebarCollapsed()

    // When collapsed we hide the label and surface it as a native tooltip instead.
    const tooltip = isCollapsed && typeof text === 'string' ? text : undefined

    return (
        <span className={isCollapsed ? `${styles.item} ${styles.collapsed}` : styles.item} title={tooltip}>
            {icon && <span className={styles.icon}>{icon}</span>}
            {!isCollapsed && <span className={styles.text}>{text}</span>}
        </span>
    )
}
